export default {"src":"/_next/static/media/WhoWeAre_014A.720dba11.JPG","height":678,"width":1920};